export const BadgeColors = {
    BLUE: 'blue',
    GREEN: 'green',
    GREY: 'grey',
    RED: 'red',
    YELLOW: 'yellow',
};
